<template>
  <div>
    <select v-model="selectedValue" class="c-input-select c-input--large u-bg--white u-txt--base" @change="onChange">
      <option value="All"> Semua {{ allLabel }} </option>
      <option v-for="option in options" :key="option" :value="option">
        {{ option }}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  name: 'ProductFilter',
  props: {
    value: {
      type: String,
      default: 'All',
    },
    filterMode: {
      type: String,
      default: 'product',
    },
    options: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selectedValue: this.value,
    };
  },
  computed: {
    allLabel() {
      return this.filterMode === 'product' ? 'Jenis Reksa Dana' : 'Bank';
    },
  },
  methods: {
    onChange(event) {
      this.$emit('input', event.target.value);
    },
  },
};
</script>
